module.exports = __webpack_public_path__ + "img/icon-customize-colored.7452bbec.svg";